export const vertexShader = 'varying vec3 N;\n' +
  'varying vec3 I;\n' +
  '//varying vec4 Cs;\n' +
  'void main()\n' +
  '{\n' +
  '    vec4 P = modelViewMatrix * vec4(position,1.0);\n' +
  '    I  = P.xyz - vec3 (0);\n' +
  '    N  = normalMatrix * vec3(normal);\n' +
  '    //Cs = gl_Color;\n' +
  '    gl_Position = projectionMatrix * modelViewMatrix  * vec4(position,1.0);\n' +
  '}';

export const fragmentShader = 'varying vec3 N;\n' +
  'varying vec3 I;\n' +
  'uniform vec4 u_color;\n' +
  'uniform float edgefalloff;\n' +
  'uniform float intensity;\n' +
  'uniform float ambient;\n' +
  'void main()\n' +
  '{\n' +
  '    float opac = dot(normalize(-N), normalize(-I));\n' +
  '    opac = abs(opac);\n' +
  '    opac = ambient + intensity*(1.0-pow(opac, edgefalloff));\n' +
  '    gl_FragColor =  opac * u_color;\n' +
  '    gl_FragColor.a = opac;\n' +
  '}';

export const adenocarcinomaFragmentShader = 'varying vec3 N;\n' +
  'varying vec3 I;\n' +
  'uniform vec4 u_color;\n' +
  'uniform float edgefalloff;\n' +
  'uniform float intensity;\n' +
  'uniform float ambient;\n' +
  'void main()\n' +
  '{\n' +
  '    float opac = dot(normalize(-N), normalize(-I));\n' +
  '    opac = abs(opac);\n' +
  '    opac = ambient + intensity*(1.0-pow(opac, edgefalloff));\n' +
  '    gl_FragColor = u_color; \n' +
  '    gl_FragColor.a = opac;\n' +
  '}';
